export default __webpack_public_path__ + "static/media/37.6630a5c3.png";